import React, { useEffect, useState } from 'react';
import BASE_URL from '../config'; // Import BASE_URL

const ShowLegacy = () => {
  const [records, setRecords] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${BASE_URL}api/proxy?action=latest_legacydata`) // Fetch legacy data
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          setRecords(data.data);
        } else {
          setError('No data found.');
        }
      })
      .catch(() => {
        setError('Failed to fetch data.');
      });
  }, []);

  return (
    <div className="container mt-4">
      <h5>Latest Legacy Records</h5>
      {error && <div className="alert alert-danger">{error}</div>}
      <div
  className="table-responsive"
  style={{ maxHeight: '400px', overflowY: 'auto' }}
>

        <table className="table table-striped table-bordered table-sm" style={{ fontFamily: 'Arial' , whiteSpace: 'nowrap' }}>
          <thead className="thead-dark">
            <tr>
              <th>ID</th>
              <th>Created</th>
              <th>Email</th>
              <th>IP</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>ZIP</th>
              <th>Loan Amount</th>
              <th>Mortgage Balance</th>
              <th>Property Value</th>
              <th>Jornaya</th>
            </tr>
          </thead>
          <tbody>
            {records.map((row, idx) => (
              <tr key={idx}>
                <td>{row.id}</td>
                <td>
  {row.created?.date
    ? (() => {
        const date = new Date(row.created.date);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const time = date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        });
        return `${day}-${month}-${year} ${time}`;
      })()
    : ''}
</td>


                <td>{row.email}</td>
                <td>{row.ip}</td>
                <td>{row.fname}</td>
                <td>{row.lname}</td>
                <td>{row.addr1}</td>
                <td>{row.city}</td>
                <td>{row.state}</td>
                <td>{row.zip}</td>
                <td>{row.loan_amount_desired}</td>
                <td>{row.mortgage_balance}</td>
                <td>{row.property_value}</td>
                <td>{row.jornaya}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShowLegacy;
